"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regFieldsSortType = exports.defaultUserPreferences = exports.defaultDatasetPreferences = void 0;
const immutable_1 = require("immutable");
const transactionsConfig_1 = require("components/TransactionRegister/transactionsConfig");
const defaultQUICKENPreferences = {
    transactionRegister: {
        doubleAmounts: false,
        editDownloaded: true,
        deleteDownloaded: true,
        autoSave: true,
        splitsInDialog: false,
        autoSearch: false,
        longCats: false,
        continuousCreate: false,
        showCurrencySymbol: false,
        wrapText: false,
        showAccountColors: false,
        currencySymbol: '$',
        registerComfort: 'normal',
        regFieldsSort: {
            cashFlow: (0, immutable_1.List)((0, transactionsConfig_1.getColumnDefaults)()),
            credit: (0, immutable_1.List)((0, transactionsConfig_1.getColumnDefaults)('credit')),
        },
    },
    calendarTransaction: {
        showTransactions: true,
        showScheduleTransactions: true,
        showDailyBalances: true,
        exceedingAmount: null,
        accountsToShow: null,
        dashboard: {
            showTransactions: true,
            showScheduleTransactions: true,
        },
    },
    accountsPrefs: null,
    ofxShadowAccountIdsSeen: [],
    accountBarBalanceType: 'today',
    accountBarShowCents: true,
    accountDrawerDefaultOpen: true,
    accountNodePrefs: (0, immutable_1.Map)({}),
    projectedOpen: false,
    upcomingOpen: true,
    overviewPageLayout: (0, immutable_1.List)(),
    qCardsOffByDefault: null,
    autoRefresh: true,
    kioskmode: false,
    dateRangeProjectedBalances: 'thirty',
    currencySymbol: '$',
    theme: null,
};
exports.defaultDatasetPreferences = defaultQUICKENPreferences;
exports.defaultUserPreferences = {
    webApp: {
        windowsReviewedWarningEnabled: true,
    },
};
function regFieldsSortType(regFieldsSort, rawType) {
    const investmentTypes = ['INVESTMENT', 'BROKERAGE', 'RETIREMENT', 'OTHER_INVESTMENT'];
    const type = investmentTypes.includes(rawType) ? 'investment' : rawType === null || rawType === void 0 ? void 0 : rawType.toLowerCase();
    if (regFieldsSort && (type in regFieldsSort)) {
        return type;
    }
    return 'cashFlow';
}
exports.regFieldsSortType = regFieldsSortType;
